module.exports = __webpack_public_path__ + "static/media/3dchart_green.84841a68.png";